import { Component } from '@angular/core';
import { LayoutFrontpageComponent } from '@mpf/ui/frontend-shared/layout-frontpage';
import { RouterLink } from '@angular/router';
import { FeedbackButtonComponent } from '@common/feedback/frontend';
import { UiButtonComponent } from '@common/ui/frontend-shared/button';

@Component({
    selector: 'mpf-download-survey',
    templateUrl: './download-survey.component.html',
    styleUrls: ['./download-survey.component.scss'],
    styles: [],
    imports: [LayoutFrontpageComponent, RouterLink, FeedbackButtonComponent, UiButtonComponent]
})
export class DownloadSurveyComponent {
	

}
